import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AllLocationsHero from './components/AllLocationsHero';
import AllLocationsContent from './components/AllLocationsContent';
import TrustBar from '../home/components/TrustBar';
import AIAnswerBlock from '../home/components/AIAnswerBlock';
import ProcessSection from '../home/components/ProcessSection';
import WhyChooseUs from '../home/components/WhyChooseUs';
import ServiceAreas from '../home/components/ServiceAreas';
import TestimonialsSection from '../home/components/TestimonialsSection';
import FAQSection from '../home/components/FAQSection';
import FinalCTA from '../home/components/FinalCTA';
import MidPageCTA from '../home/components/MidPageCTA';

export default function LocationsPage() {
  return (
    <div className="min-h-screen font-sans">
      <Header />
      <main>
        {/* 1. Hero */}
        <AllLocationsHero />
        {/* 2. Trust Bar */}
        <TrustBar tagline="Trusted by Creators, Agencies & Production Teams Across the US" />
        {/* 3. All Locations Content */}
        <AllLocationsContent />
        {/* Urgency CTA */}
        <MidPageCTA variant="urgency" />
        {/* 4. AI Answer Block */}
        <AIAnswerBlock />
        {/* 5. Process */}
        <ProcessSection />
        {/* 6. Why Choose Us */}
        <WhyChooseUs />
        {/* 7. Service Areas */}
        <ServiceAreas />
        {/* 8. Testimonials */}
        <TestimonialsSection />
        {/* Social CTA */}
        <MidPageCTA variant="social" />
        {/* 9. FAQ */}
        <FAQSection />
        {/* 10. Final CTA */}
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
